// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CopyBoardView } from 'app/scripts/views/board/CopyBoardView';

export const copyBoard = function (e) {
  stopPropagationAndPreventDefault(e);
  return PopOver.toggle({
    elem: $(e.target, this.$el).closest('.js-copy-board'),
    view: new CopyBoardView({ model: this.model, modelCache: this.modelCache }),
  });
};
